<template>
  <div class="procedures" @click="openProcedures">
    <img :src="proceduresImg" />
    <div>操作手册</div>
  </div>
</template>

<script>
import proceduresImg from '@/assets/czsc.png';

export default {
  props: {
    url: {
      // 预览地址
      type: String,
      default: '',
    },
  },
  data() {
    return {
      proceduresImg,
    };
  },
  methods: {
    openProcedures() {
      if (this.url) {
        const src = `https://jk.lockhea.com/procedures/${this.url}.pdf`;
        window.open(src, '_blank');
      } else {
        this.$Message.info('当前页面暂无操作手册');
      }
    },
  },
};
</script>

<style scoped lang="less">
.procedures {
  position: fixed;
  display: block;
  right: -5px;
  bottom: 130px;
  padding: 5px;
  text-align: center;
  z-index: 9;
  color: #2d2d30;
  font-weight: bold;
  background-color: #fff;
  border-radius: 8px;
  border: #2d2d30 1px solid;
  cursor: pointer;
  width: 30px;
  font-size: 12px;
  transition: 600ms;
  img {
    display: none;
  }
  &:hover {
    right: 7px;
    padding: 5px;
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    -webkit-box-shadow: 1px 3px 7px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 1px 3px 7px 0 rgba(0, 0, 0, 0.5);
    transition: 700ms;
  }
  &:hover img {
    display: block !important;
    width: 30px;
    height: 30px;
  }
}
</style>
